import React from 'react';
import LinkedSubjects from '.';

const view = 'scoping';
const linkedSubjectsView = "victims";

function TAZAMAVictims() {
  return <LinkedSubjects view={view} linkedSubjectsView={linkedSubjectsView} />
};

export default TAZAMAVictims;
